import "bootstrap/dist/css/bootstrap.min.css";
import "./src/scss/styles.scss";
import "./src/scss/common.scss"
import "./src/scss/desktop.scss"
import "./src/scss/loader.scss"
import "typeface-roboto";

export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    // Show loader immediately
    const loader = document.createElement('div');
    loader.id = 'gatsby-loader';
    loader.innerHTML = `
      <div class="loader-container">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    `;
    document.body.appendChild(loader);
    
    window.addEventListener("message", (event) => {
      const { type, data } = event.data;
      if (type === "EDUCATION_DATA") {
        sessionStorage.setItem("educationData", JSON.stringify(data));
        window.dispatchEvent(new CustomEvent("educationDataReceived", { 
          detail: data 
        }));
      }
    });
  }
};

export const onInitialClientRender = () => {
  // Remove loader after page is ready
  if (typeof window !== "undefined") {
    setTimeout(() => {
      const loader = document.getElementById('gatsby-loader');
      if (loader) {
        loader.style.opacity = '0';
        loader.style.transition = 'opacity 0.3s ease-in-out';
        setTimeout(() => {
          loader.remove();
        }, 300);
      }
    }, 100);
  }
};